import { removeAccents } from '../utils/common';

export const removeSpace = (text: string | null | undefined): string =>
  text?.replace(/\s/g, '') ?? '';

export const formatDecimal = (
  value: string | null | undefined,
  decimalSeparator: 'comma' | 'dot' = 'dot',
): string =>
  removeSpace(value).replace(
    decimalSeparator === 'dot' ? ',' : '.',
    decimalSeparator === 'dot' ? '.' : ',',
  );

export const parseDecimal = (value: string | null | undefined): number => {
  const decimal = parseFloat(formatDecimal(value));
  return !value || isNaN(decimal) ? 0.0 : decimal;
};

export const fixedDecimalPercentage = (
  value: number,
  decimalsNumber: number = 2,
) =>
  ((Number(value) || 0) * 100).toFixed(decimalsNumber).replace('.', ',') + ' %';

export const getName = (firstName: string | null, lastName: string | null) =>
  `${firstName ? firstName : ''} ${lastName ? lastName : ''}`.trim();

export const removeAccentsAndUpperCase = (text: string) =>
  removeAccents(text).toLowerCase();

export function insert<T>(arr: T[], index: number, newItem: T) {
  return [...arr.slice(0, index), newItem, ...arr.slice(index)];
}

export const not = (a: any[], b: any[], key?: string) => {
  return a.filter(
    (_) =>
      b.findIndex((__) =>
        key !== undefined ? _[key] === __[key] : _ === __,
      ) === -1,
  );
};

export const intersection = (a: any[], b: any[], key?: string) => {
  return a.filter(
    (_) =>
      b.findIndex((__) =>
        key !== undefined ? _[key] === __[key] : _ === __,
      ) !== -1,
  );
};

export const union = (a: any[], b: any[], key?: string) => {
  return [...a, ...not(b, a, key)];
};
